<div id="home-page" class="page-wrapper">
  <div class="page-inner">
    <div class="page-content">
      <div class="left-wrapper">
        <div class="nest-section">
          <img class="nest-logo" src="assets/images/nest-logo.svg" alt="NEST" />
        </div>
      </div>
      <div class="right-wrapper">
        <div class="form-section">
          <div class="home-logo">
            <img [src]="env.imgLogo" [alt]="env.supplierName" />
            <app-tier-tag class="d-flex justify-content-center ml-tier-tag"></app-tier-tag>
          </div>
          <div class="welcome-text">
            <h2>Welcome Back</h2>
            <p>Enter your username and password<br />to access your account.</p>
          </div>
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
    <div class="footer-section">
      <p class="footer">&copy; {{ env.copyRight }} <app-version-tag></app-version-tag></p>
    </div>
  </div>
</div>
